/**
 * Database Collections.
 */

export const ACTIVITIES = "activities";
export const DOCUMENTATION_EXERCISES = "documentation_exercises";
export const GAMES = "games";
export const USERS = "users";
export const USERS_DOCUMENTS = "users_documents";
export const USERS_EVENTS = "users_events";
export const USERS_PENDING_EVENTS = "users_pending_events";
export const USERS_REPORTS = "users_reports";
export const USERS_SUBSTITUTES = "users_substitutes";
export const USERS_TESTS = "users_tests";
export const USERS_GROUPED_TESTS = "users_grouped_tests";
export const USERS_UPLOADS = "users_uploads";
/**
 * Fields.
 */
export const _ID = "_id";
export const ADDRESS = "address";
export const ADDRESS_COUNTRY = "address.country";
export const ADDRESS_STATE = "address.state";
export const ADDRESS_STREET = "address.street";
export const ADDRESS_ZIP_CITY = "address.zip_city";
export const AVAILABLE_SESSIONS = "available_sessions";
export const ADDITIONAL_BUFFER = "additional_buffer";
export const ABSENT_THERAPIST = "absent_therapist";
export const BANKTRANSFER_PAYMENT_ID = "banktransfer_id";
export const BIRTHDAY = "birthday";
export const CLASS = "class";
export const EXISTING_DIAGNOSES = "existing_diagnoses";
export const HOBBIES = "hobbies";
export const CHILD = "child";
export const OTHER = "other";
export const SCHOOL_RELIEF = "school_relief";
export const SCHOOL_TYPE = "school_type";
export const SPECIAL_CLASS = "special_class";
export const SUBSTITUTE_ID = "substitute_id";
export const DYSLEXIA_DIAGNOSTICS = "dyslexia_diagnostics";
export const DYSLEXIA_OTHER_DIAGNOSTICS = "dyslexia_other_diagnostics";
export const CREATION_TIMESTAMP = "creation_timestamp";
export const CRM_ID = "crm_id";
export const CUSTOMER_ID = "customer_id";
export const COLOR = "color";
export const CANCELED_DATES = "canceled_dates";
export const CONTRACT_END_DATE = "end_date";
export const CREATED_AT = "created_at";
export const CAN_JOIN_GROUPED_SESSION = "can_join_grouped_session";
export const DESCRIPTION = "description";
export const DISPLAY_DURATION = "display_duration";
export const DOCUMENTS = "documents";
export const EMAIL = "email";
export const END = "end";
export const EVAL_SESSION_DATE = "eval_session_date";
export const EVALUATION = "evaluation";
export const EVENTS = "events";
export const EXDATE = "exdate";
export const EXECUTIONS = "executions";
export const EXERCISES = "exercises";
export const EXRULE = "exrule";
export const FILE = "file";
export const FILES = "files";
export const FILE_ID = "file_id";
export const FONT = "font";
export const FREE_SLOT = "free_slot";
export const PAID_AT = "paid_at";
export const GDRIVE = "gdrive";
export const GCS_STORAGE = "gstorage";
export const GENDER = "gender";
export const GUESTS = "guests";
export const ID = "id";
export const IMAGE = "image";
export const IMAGE_LINK = "image_link";
export const INDEX = "index";
export const IS_ACTIVE = "is_active";
export const IS_DONE = "is_done";
export const IS_FROM_CONCEPT = "is_from_concept";
export const IS_SHARED = "is_shared";
export const IS_SUBSTITUTED = "isSubstituted";
export const IS_SUBSTITUTE_EVENT = "isSubstituteEvent";
export const INITIATED_AT = "initiated_at";
export const LINK = "link";
export const LINK_DOWNLOAD = "link_download";
export const LOCATION = "location";
export const LASTNAME = "lastname";
export const MEETING_LINK = "meeting_link";
export const MEISTER_CODY_CODE = "meister_cody_code";
export const METHOD = "method";
export const MOLLIE_PAYMENT = "mollie_payment";
export const SUBSCRIPTIONS = "subscriptions";
export const UPSELL = "strongparents_training";
export const TEMP = "temp";
export const NAME = "name";
export const NOTE = "note";
export const NOTES = "notes";
export const OVERALL_RATING = "overall_rating";
export const ORDER = "order";
export const PARAMS = "params";
export const PARENT_ID = "parent_id";
export const PARENTS_CONVERSATION = "parents_conversation";
export const PASSWORD = "password";
export const PAYMENT_ID = "payment_id";
export const PERSONAL_DESCRIPTION = "personal_description";
export const PHONE = "phone";
export const PICTURE = "picture";
export const PRICE_SESSION = "price_session";
export const PROFESSIONAL_TITLE = "professional_title";
export const PAYMENT_AMOUNT = "payment_amount";
export const PAYMENT_PLAN = "payment_plan";
export const PERMISSIONS = "permissions";
export const PENDING_BOOKINGS = "pendingBookings";
export const RATING = "rating";
export const RECURRENCE = "recurrence";
export const REGISTRATION_CODE = "registration_code";
export const REGISTRATION_STEP = "registration_step";
export const RESET_PASSWORD_CODE = "reset_password_code";
export const RESULT = "result";
export const RESULTS = "results";
export const ROLE = "role";
export const READING = "reading";
export const RRULE = "rrule";
export const SEQUENCES = "sequences";
export const START = "start";
export const START_TIMESTAMP = "start_timestamp";
export const STATUS = "status";
// export const SUBSCRIPTION_NAME = "name";
export const SESSION = "session";
export const SESSION_IDS = "session_ids";
export const SESSION_FREQUENCY = "frequency";
export const SESSION_START_DATE = "start_date";
export const SESSION_END_DATE = "end_date";
export const SUBSTITUTES = "substitutes";
export const TESTS = "tests";
export const TEST_RESULT = "test_result";
export const THERAPIST = "therapist";
export const THERAPISTS = "therapists";
export const THERAPIST_EMAIL = "therapist_email";
export const THERAPIST_ID = "therapist_id";
export const THERAPIST_NAME = "therapist_name";
export const AVAILABLE_BUFFER = "available_buffer";
export const THERAPY_SESSION = "therapy_session";
export const TIMESTAMP = "timestamp";
export const TITLE = "title";
export const TYPE = "type";
export const TRAINING = "training";
export const UPDATE_TIMESTAMP = "update_timestamp";
export const UPLOAD_TIMESTAMP = "upload_timestamp";
export const CREATED_BY = "created_by";
export const UPLOADS = "uploads";
export const VERSION = "version";
export const VIDEO_LINK = "video_link";
export const USER_DIRECTORY = "user_directory";
export const WORD = "word";
export const WORDS = "words";
export const WRITING = "writing";
export const PREFERRED_DATES = "preferred_dates";
export const WELCOME_EMAIL_SENT = "welcome_email_sent";
export const THERAPY_PROGRAM = "therapy_program";
export const FEEDBACK = "feedback";
export const LAST_FEEDBACK = "last_feedback_at";
export const POSTPONED = "postponed_at";
